import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ManualDataUpdateComponent} from './manual-data-update.component';

const routes: Routes = [
	{
		path: '',
		component: ManualDataUpdateComponent,
	},
];

@NgModule({
	imports: [
		RouterModule.forChild(routes),
	],
	exports: [
		RouterModule,
	],
})
export class ManualDataUpdateRoutingModule { }